export const ALLOWED_FILE_TYPES = ["xlsx"];
export const NO_FILE_TEXT = "No File Selected!";